import React, { Component, useState } from "react";
import {
  View,
  ScrollView,
  Image,
  StyleSheet,
  Dimensions,
  FlatList,
  TouchableOpacity,
  Platform,
  ActivityIndicator,
  TouchableNativeFeedback,
  TouchableWithoutFeedback,
  Linking,
  RefreshControl,
  ImageBackground,
  SafeAreaView,
} from "react-native";
import AsyncStorage from "@react-native-community/async-storage";
import { Button, Card, Surface, Appbar } from "react-native-paper";
import Carousel from "./../../components/carousel";
import Toaster from "./../../components/snackBar_toaster";
import { motion } from "framer-motion"

import CurrentAffairs from "./CurrentAffairs";

import Colors from "./../../constants/theme";
import HomeSkeltonLoading from "./homeSkeltonPlaceholder";
import Container from '@material-ui/core/Container';
// import AdsScreen from "./../Ads";





import {
  getHomeInfo,
  dispatchClearHomeInfo,
  getCurrentAffairs,
  dispatchClearCurrentAffairs,
  adsInfo,
  clearAdsInfo,
} from "./../../store/actions";
import { Text, Styles as newStyles } from "./../../components/UI-Components";
import { connect } from "react-redux";

import Header from "./../../components/Header";

import CourseNTestSeriesComponent from "./courseNTestSeriesComponent";


const Loader = require('./../../assets/loadingGif.gif');

export const HoverComponent = ({children}) => (
        <motion.div
          whileHover={{ scale: 1.03 }}
          whileTap={{ scale: 0.9 }}
          className={'cursor-pointer'}
      
      >{children}</motion.div>
)

const { width, height } = Dimensions.get("window");

const _width = window.innerWidth;

const horizontalMargin = 0;
// const slideWidth = 415;
const slideWidth = width;
const sliderWidth = Dimensions.get("window").width;
const itemWidth = sliderWidth + horizontalMargin * 2;
const imgWidth = itemWidth - 5;
const itemHeight = 180;

const ColorCodes = ["#FF5F6D", "#16A085", "#8E44AD", "#4761C9"];

const Slide = ({ item, index }) => {
  const { slider_screen } = item;
  const { fe_screen_id = 1 } = slider_screen || {};
  

  return (
      <Image
        source={{ uri: `${item.slider_image}` }}
        style={styles.carouselImage}
        key={index}
        resizeMode='cover'
      />
  );
};

class HomeScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isConnected: true,
      refreshing: false,
      activeSlide: 0,
    };
  }

  handleConnectivityChange = (isConnected) => {
    if (isConnected) {
      this.setState({ isConnected });
    } else {
      this.setState({ isConnected });
    }
  };

  componentDidMount() {
    this.props.adsInfo();
    this.getHomeData();
  }

  getHomeData = () => {
    if (!this.props.data) {
      this.props.getHomeInfo();
      this.props.getCurrentAffairs({}, false);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.err !== this.props.err) {
      if (this.props.err && this.props.errInfo) {
        setTimeout(() => {
          this.props.history.push("Login");
        }, 1000);
      }
    }

    if (prevProps.data !== this.props.data) {
      if (this.props.data) {
        this.setState({
          refreshing: false,
        });
      }
    }
  }

  componentWillUnmount() {
    
  }

  showToaster = (msg, time) => {
    this.setState({
      show: true,
      toasterMsg: msg,
    });
  };

  isAd = () => {
    this.setState({
      isAdShow: true,
    });
  };

  render() {
    const { loading, err, errInfo, sliderImages } = this.props;

    return (
      <>
        <Header
          title="Home"
        />
        <>
        <div className={`${loading ? "main-component" : 'full-height'} `}>
        <SafeAreaView
          style={{ flex: 1, marginTop: 0,  backgroundColor: "#fff",}}
        >
          {!loading && !err ? (
            <View
              style={{
                flex: 1,
                backgroundColor: "#fff",
                paddingTop: 5,
                height: "100%",               
              }}
            >
              {sliderImages && sliderImages.length > 0 && (
                <Carousel>
                  {sliderImages.map((item, index) => {
                    return(
                       <Slide item={item} index={index} key={index} />
                    ) 
                  })}
                </Carousel>
              )}


              <CourseNTestSeriesComponent navigation={this.props.history} />

              {/* <View
                style={{
                  marginBottom: 20,
                  marginTop: 10,
                  paddingBottom: this.state.isAdShow ? 50 : 0,
                }}
              >
                {this.props.currentAffairs &&
                this.props.currentAffairs.length > 0 ? (
                  <>
                    <Text
                      style={{
                        marginHorizontal: 12,
                        marginVertical: 6,
                        color: "#000",
                        fontSize: 16,
                        fontWeight: "700",
                      }}
                    >
                      Articles
                    </Text>
                    <CurrentAffairs
                      navigation={this.props.history}
                      currentAffairs={this.props.currentAffairs}
                      adsTrue={false}
                      fromList={false}
                      ref={"current"}
                    />
                  </>
                ) : null}
                <TouchableWithoutFeedback
                      onPress={() => this.props.history.push('/ListOfCurrentAffairs')}
                      style={{cursor: 'pointer'}}
                    >
                      <Text style={styles.viewMore}>View More</Text>
                    </TouchableWithoutFeedback>
              </View> */}
            </View>
          ) : loading && !err ? (
            <View style={{width: '100%', height: '90vh', justifyContent: 'center', alignItems: 'center',}}>

              {/* <ActivityIndicator /> */}
              <Image source={Loader} style={{width: 250, height: 250}}/>
            </View>
          ) : (
            // <HomeSkeltonLoading />
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            ></View>
          )}
          {/* ================ads screen ====================== */}
          {/* {!loading && (
            <AdsScreen screenName={"Home"} isAdCallBack={this.isAd} />
          )} */}
          {/* ================ads screen end ====================== */}
          {/* <View>
        <Text style={{backgroundColor:'red'}}>Hello from Article {id}!</Text>
        </View> */}
        </SafeAreaView>
        </div>
        </>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  testType: state.testType && state.testType.type,
  data: state.homeData && state.homeData.res && state.homeData.res,
  appVersion:
    state.homeData && state.homeData.res && state.homeData.res.os_version,
  loading: state.homeData && state.homeData.loading && state.homeData.loading,
  err: state.homeData && state.homeData.err && state.homeData.err,
  errInfo: state.homeData && state.homeData.errInfo && state.homeData.errInfo,
  sliderImages:
    (state.homeData &&
      state.homeData.sliderImages &&
      state.homeData.sliderImages) ||
    [],
  examPreferences:
    state.homeData &&
    state.homeData.examPreferences &&
    state.homeData.examPreferences,
  testOfUsers:
    state.homeData && state.homeData.testOfUsers && state.homeData.testOfUsers,
  testByAdmin:
    state.homeData && state.homeData.testByAdmin && state.homeData.testByAdmin,
  currentAffairs:
    state.currentAffairs &&
    state.currentAffairs.response &&
    state.currentAffairs.response.current_affairs &&
    state.currentAffairs.response.current_affairs,
  // currentAffairs: state.currentAffairs && state.currentAffairs.response && state.currentAffairs.response,
  addTestError: state.addTest && state.addTest.error,
  addTestSuccess: state.addTest && state.addTest.response,
  dailyMockTestData:
    state.homeData && state.homeData.res && state.homeData.res.mock_series_list,
});

export default connect(mapStateToProps, {
  adsInfo,
  getHomeInfo,
  dispatchClearHomeInfo,
  getCurrentAffairs,
  dispatchClearCurrentAffairs,
})(HomeScreen);

const styles = StyleSheet.create({
  mainPractiseTestView: {
    width: 105,
    height: 105,
    marginTop: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fcfcfc",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.9,
    shadowRadius: 1.3,
    elevation: 1,
    marginLeft: 5,
    borderRadius: 18,
    marginRight: 8,
    elevation: 9,
  },
  carouselImage: {
    width: "100%",
    // height: _width >= 578 ? 600 : 200,
    height: 400,
    // paddingTop:50,
    justifyContent: "center",
    alignItems: "center",
    // marginVertical: 8,
    marginHorizontal: 5,
    backgroundColor: Colors.imageBgColor,
  },
  testName: {
    fontSize: 14,
    color: "#fff",
    ...Platform.select({
      android: {
        // ...robotoWeights.bold
      },
      ios: {
        // ...sanFranciscoWeights.bold
      },
    }),
    color: Colors.black,
    fontSize: 14,
  },
  days: {
    fontSize: 10,
    ...Platform.select({
      android: {
        // ...robotoWeights.medium
      },
      ios: {
        // ...sanFranciscoWeights.medium
      },
    }),
  },
  slide: {
    width: imgWidth,
    height: itemHeight,
  },
  slideInnerContainer: {
    width: slideWidth,
    flex: 1,
  },
  paginationStyle: {
    ...Platform.select({
      ios: {
        backgroundColor: "transparent",
        position: "absolute",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        top: 135,
      },
      android: {
        backgroundColor: "transparent",
        position: "absolute",
        alignItems: "center",
        margin: "auto",
        width: "100%",
        top: 135,
      },
    }),
  },
  surface: {
    borderColor: "#fff",
    alignItems: "center",
    justifyContent: "center",
  },

  plusIcon: {
    borderWidth: 1,
    borderColor: "#222",
    marginVertical: 10,
    backgroundColor: "#222",
    width: 30,
    height: 30,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 50,
    // paddingBottom:10
  },
  heading: {
    fontSize: 20,
    color: "#222",
    paddingLeft: 20,
    marginVertical: 20,
    ...Platform.select({
      android: {
        // ...robotoWeights.bold,
      },
      ios: {
        // ...sanFranciscoWeights.bold,
      },
    }),
  },
  headerTitle: {
    ...Platform.select({
      android: {
        width: 30,
        height: 30,
        // textAlign:'center',
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        position: "absolute",
        left: "38%",
        right: 0,
        margin: "auto",
      },
      ios: {
        width: 30,
        height: 30,
        textAlign: "center",
        alignItems: "center",
        alignSelf: "center",
        justifyContent: "center",
        //  position:'absolute',
        //  left:'40%'
      },
    }),
  },
  examImage: {
    ...Platform.select({
      android: {
        width: 30,
        height: 30,
        marginTop: 10,
        borderRadius: 30,
        borderWidth: 2,
        borderColor: "#fff",
      },
      ios: {
        width: 40,
        height: 40,
        marginTop: 10,
        borderRadius: 20,
        borderWidth: 2,
        borderColor: "#fff",
      },
    }),
  },

  testSeriesStrip: {
    flex: 1,
    marginTop: -12,
  },
  // challengeComponent:{
  //   width:500,
  //   height:hp(30),
  //   resizeMode:'contain',
  // }

  viewMore: {
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    paddingVertical: 2,
    flex: 1,
    cursor: 'pointer',
    // backgroundColor: '#f00',
    paddingHorizontal: 5,
    color: newStyles.primaryColor,
    fontSize: 16,
    fontWeight: "600",
  },
});
